import { integrationSyncHistoryService } from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

const useFetchLatestIntegrationSyncRuns = (enabled = true) => {
  return useQuery({
    queryKey: ['fetchLatestIntegrationSyncRuns'],
    queryFn: () => integrationSyncHistoryService.getLatestRuns(),
    enabled,
  });
};

export default useFetchLatestIntegrationSyncRuns;
